import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = ["for"]
const _hoisted_3 = { class: "form-control-checkbox" }
const _hoisted_4 = ["name"]
const _hoisted_5 = { class: "help-block" }

import { PropType } from "vue";
import { IUmbracoFormField } from "@/models/umbraco-forms/IUmbracoFormField";
import UmbracoFormInput from "@/components/umbraco-forms/inputs/UmbracoFormInput.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UmbracoFormDataConsent',
  props: {
  field: {
    type: Object as PropType<IUmbracoFormField>,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      for: __props.field.id,
      class: "umbraco-forms-label"
    }, _toDisplayString(__props.field.caption), 9, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(UmbracoFormInput, {
        type: "checkbox",
        field: __props.field,
        value: "true",
        id: __props.field.id
      }, null, 8, ["field", "id"]),
      _createElementVNode("input", {
        type: "hidden",
        name: __props.field.alias,
        value: "false"
      }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("p", _hoisted_5, _toDisplayString(__props.field.helpText), 1)
  ]))
}
}

})